import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserModels } from '@share-models';
import { api } from '../consts/url';

@Injectable({ providedIn: 'root' })
export class UserService {
  constructor(private http: HttpClient) {}

  public getUserProfile(): Observable<UserModels.UserDocument> {
    return this.http.put<UserModels.UserDocument>(api.user.getProfile, {});
  }
}
